import React, { FC, useEffect, useRef, useState } from 'react';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';

import { useSelector } from 'bus';

import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { NumberBox, Popup, Validator } from 'devextreme-react';

import { setReportPassport } from 'bus/report/actions';
import { SetReportPassportRequest } from 'bus/report/types';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

type Props = {
  visible: boolean;
  onClose: () => void;
  dataPassport: SetReportPassportRequest | null;
};

const ReportPassportModal: FC<Props> = ({ visible, onClose, dataPassport }) => {
  const { loading } = useSelector((store) => store.report.setReportPassport);
  let validationRef = useRef<ValidationGroup>(null);
  const dispatch = useDispatchPromise();

  const [form, setForm] = useState<SetReportPassportRequest>({
    requestWorkId: 0,
    updNumber: '',
    nomenclature: '',
    additiveName: '',
    quantity: 0,
  });

  useEffect(() => {
    if (dataPassport) {
      setForm(dataPassport);
    }
  }, [dataPassport]);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (validationRef.current?.instance.validate().isValid) {
      await dispatch(setReportPassport.async({ ...form }));
      onClose();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={onClose}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Отчет"
        width={400}
        onHidden={onClose}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={validationRef}>
                <Form id="report" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFiledBox label="Номер" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder=""
                        mode="text"
                        value={form.updNumber}
                        onValueChange={(e: any) => {
                          setForm((prev) => ({ ...prev, updNumber: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Номер" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>
                    <AppFiledBox label="Номенклатура" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder=""
                        mode="text"
                        value={form.nomenclature}
                        onValueChange={(e: any) => {
                          setForm((prev) => ({ ...prev, nomenclature: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Номенклатура" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>
                    <AppFiledBox label="Объем" labelTop>
                      <NumberBox
                        stylingMode="underlined"
                        placeholder="Объем"
                        format="###0.##"
                        value={form.quantity}
                        onValueChanged={(e) => {
                          setForm((prev) => ({ ...prev, quantity: e.value }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Объем" />
                        </Validator>
                      </NumberBox>
                    </AppFiledBox>
                    <AppFiledBox label="Наименование добавки" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder=""
                        mode="text"
                        value={form.additiveName}
                        onValueChange={(e: any) => {
                          setForm((prev) => ({ ...prev, additiveName: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Наименование добавки" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>
                  </Item>
                </Form>

                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={onClose}
                  disabledSubmit={loading}
                  textConfirm={loading ? 'Загрузка' : 'Скачать'}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ReportPassportModal;
